// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__MsSaE","heroContent":"hero_heroContent__RwXkx","anim-desktop":"hero_anim-desktop__EYE7C","anim-mobile":"hero_anim-mobile__cmhY8"};